module.exports = __webpack_public_path__ + "static/media/bolang.8e5b7cc.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/bolang.mp4
// module id = bV3R
// module chunks = 0